import { render, staticRenderFns } from "./AppLayoutNestedContent.vue?vue&type=template&id=348d643e&scoped=true"
import script from "./AppLayoutNestedContent.vue?vue&type=script&lang=js"
export * from "./AppLayoutNestedContent.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutNestedContent.vue?vue&type=style&index=0&id=348d643e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348d643e",
  null
  
)

export default component.exports